import _extends from "@babel/runtime/helpers/esm/extends";
// GENERATE BY ./scripts/generate.ts
// DON NOT EDIT IT MANUALLY

import * as React from 'react';
import AudioFilledSvg from "@ant-design/icons-svg/es/asn/AudioFilled";
import AntdIcon from "../components/AntdIcon";
var AudioFilled = function AudioFilled(props, ref) {
  return /*#__PURE__*/React.createElement(AntdIcon, _extends({}, props, {
    ref: ref,
    icon: AudioFilledSvg
  }));
};
if (process.env.NODE_ENV !== 'production') {
  AudioFilled.displayName = 'AudioFilled';
}
export default /*#__PURE__*/React.forwardRef(AudioFilled);